import React, { useEffect } from 'react'
import Breadcrumb from '../common/Breadcrumb'
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
import { BiPlusCircle } from 'react-icons/bi';

const Transportation = () => {
  
// Array of images for easier management
  const images = [    
    {
      src: '/images/gallery/transport-1.png',
      alt: 'Modern classroom with technology',
    },
   {
      src: '/images/gallery/transport-2.png',
      alt: 'Modern classroom with technology',
    },
   {
      src: '/images/gallery/transport-3.png',
      alt: 'Modern classroom with technology',
    },
    {
      src: '/images/gallery/transport-4.png',
      alt: 'Modern classroom with technology',
    },
  ];
 useEffect(() => {
      NativeFancybox.bind("[data-fancybox='gallery']", {
        infinite: true,
        Toolbar: {
          display: {
            left: ["infobar"],
            right: ["slideshow", "thumbs", "close"],
          },
        },
        Thumbs: {
          autoStart: false,
        },
        caption: (fancybox, slide) => {
          return slide.$trigger?.dataset?.caption || slide.$trigger?.title || "";
        },
      });
  
      return () => {
        NativeFancybox.destroy();
      };
    }, []);
  return (
    <>
      <Breadcrumb 
            pageTitle="Transportation"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "Transportation" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />
      <section className="space-ptb">
         <div class="container">
          <div className="row align-items-center">
            <div className="col-md-12">
              <div className="section-title mb-4">
                <h2 className="title">
                  <span className="text-primary">Transportation</span>
                </h2>
                <div className="curved-line mx-auto mt-3"></div>
              </div>
            </div>
          </div>       
     
          <div className='smart-classroom'>
          <div className="my-shuffle-container row columns-4 popup-gallery full-screen">
                          {images.map((image) => (
                            <div key={image.id} className="grid-item" data-group={image.group}>
                              <div className="portfolio-item">
                                <div className="position-relative">
                                  <img
                                    className="img-fluid"
                                    src={image.src}
                                    alt={image.alt}
                                    loading="lazy"
                                  />
                                  <div className="portfolio-overlay">
                                    <a
                                      data-fancybox="gallery"
                                      data-caption={image.title}
                                      href={image.src}
                                      title={image.title}
                                      className="portfolio-img"
                                    >
                                      <i>
                                        <BiPlusCircle size={40} />
                                      </i>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
          <div className="description">
            <p className="description-text">
              School rickshaw/bus facility, if availed of by guardians, will be for the entire session. In exceptional cases a guardian may discontinue it by giving one month notice or one month transport fee.
            </p>
            <p className="description-text">
              In case of the school rickshaw/bus does not reach on time due to mechanical breakdown or due to the illness of the puller/ driver, guardians are requested to make their own alternative arrangements. However, the school tries its best to provide satisfactory transport service.
            </p>
           
          </div>      
          </div> 
          </div>
      </section>

      <style jsx>{`       
        .smart-classroom {
          padding: 20px 20px;
          background: #f8f8f8;
          margin-bottom:40px;
          border-radius:5px;
        }

        .image-gallery {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 20px;
          margin-bottom: 30px;          
        }

        .image-item img {
          width: 100%;
          height: 200px;
          object-fit: cover;
          border-radius: 8px;
          border: 1px solid #e2e8f0;
          transition: transform 0.3s ease;
        }

        .image-item img:hover {
          transform: scale(1.05);
        }


        .description-text {
          font-size: 1rem;
          line-height: 1.6;
          color: #4a5568;
          margin-bottom: 15px;
          text-align: justify;
        }

        .description-text:last-child {
          margin-bottom: 0;
        }

        @media (max-width: 768px) {          

          .image-gallery {
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 15px;
          }

          .image-item img {
            height: 150px;
          }

          .description-text {
            font-size: 0.95rem;
            text-align: left;
          }
        }

        @media (max-width: 480px) {    
          .image-gallery {
            grid-template-columns: 1fr;
          }

          .image-item img {
            height: 120px;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .smart-classroom {
          animation: fadeIn 0.5s ease-out;
        }

        .image-item img:focus {
          outline: 2px solid #2c5282;
          outline-offset: 2px;
        }
      `}</style>
    </>
  );
};


export default Transportation
